(function () {
    // After WooCommerce AJAX add-to-cart: update button href to cart URL
    // so clicking the "added" button navigates to cart instead of re-adding.
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
            if (!$button || !$button.length) return;
            var $cartLink = $button.siblings('a.added_to_cart');
            if ($cartLink.length) {
                $button.attr('href', $cartLink.attr('href')).removeClass('ajax_add_to_cart');
            }
        });
    }

    if (window.scrollY > 0) {
        document.body.classList.add('scrolled');
    }

    window.addEventListener('scroll', function () {
        if (window.scrollY > 0) {
            document.body.classList.add('scrolled');
        } else {
            document.body.classList.remove('scrolled');
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        // Quantity stepper: inject − and + buttons around WooCommerce qty inputs
        function initQtyButtons(root) {
            (root || document).querySelectorAll('form.cart input.qty').forEach(function (input) {
                if (input.parentElement.querySelector('.qty-btn')) return;

                var minus = document.createElement('button');
                minus.type = 'button';
                minus.className = 'qty-btn qty-minus';
                minus.textContent = '−';
                minus.setAttribute('aria-label', 'Reduir quantitat');

                var plus = document.createElement('button');
                plus.type = 'button';
                plus.className = 'qty-btn qty-plus';
                plus.textContent = '+';
                plus.setAttribute('aria-label', 'Augmentar quantitat');

                input.parentElement.insertBefore(minus, input);
                input.parentElement.appendChild(plus);

                minus.addEventListener('click', function () {
                    var min  = parseFloat(input.min)  || 1;
                    var step = parseFloat(input.step) || 1;
                    var val  = parseFloat(input.value) || min;
                    if (val - step >= min) {
                        input.value = val - step;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });

                plus.addEventListener('click', function () {
                    var max  = parseFloat(input.max);
                    var step = parseFloat(input.step) || 1;
                    var val  = parseFloat(input.value) || 1;
                    if (isNaN(max) || val + step <= max) {
                        input.value = val + step;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            });
        }

        initQtyButtons();

        // Re-init after WooCommerce variation updates swap the form HTML
        document.addEventListener('found_variation', function () { initQtyButtons(); });
        document.addEventListener('reset_data',      function () { initQtyButtons(); });

        // Desktop menu toggle
        const menuToggle = document.querySelector('.menu-toggle');
        const dropdownMenu = document.querySelector('.dropdown-menu');

        if (menuToggle && dropdownMenu) {
            menuToggle.addEventListener('click', function () {
                dropdownMenu.classList.toggle('open');
                this.classList.toggle('active');
            });
        }

        // Mobile menu toggle
        const mobileMenu = document.querySelector('.menu-toggle-mobile');
        const mobileDropdown = document.querySelector('.dropdown-menu-mobile');

        if (mobileMenu && mobileDropdown) {
            mobileMenu.addEventListener('click', function () {
                const isOpen = mobileDropdown.classList.toggle('open');
                this.classList.toggle('active');
                this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        }

        // Submenu toggle on mobile
        const submenuLinks = document.querySelectorAll('.menu-item-has-children > a');

        submenuLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                if (window.innerWidth <= 1200) {
                    e.preventDefault();
                    const parentLi = this.parentElement;
                    parentLi.classList.toggle('show-menu');
                }
            });
        });

        // Copy link to clipboard
        const copyLink = document.querySelector('.copy-link');
        if (copyLink) {
            copyLink.addEventListener('click', function () {
                const url = this.getAttribute('data-url');
                const copiedText = this.getAttribute('data-message') || 'Copied!';
                const button = this;

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(url).then(function () {
                        showCopyPopup(button, copiedText);
                    });
                } else {
                    // Fallback per a navegadors antics
                    const tempInput = document.createElement('input');
                    tempInput.type = 'text';
                    tempInput.value = url;
                    document.body.appendChild(tempInput);
                    tempInput.select();
                    document.execCommand('copy'); // eslint-disable-line
                    document.body.removeChild(tempInput);
                    showCopyPopup(button, copiedText);
                }
            });
        }

        // Category mobile select redirect
        const categorySelect = document.querySelector('.ruth2m-post-list__select-category-movil');
        if (categorySelect) {
            categorySelect.addEventListener('change', function () {
                if (this.value) {
                    window.location.href = this.value;
                }
            });
        }
    });

    function showCopyPopup(button, text) {
        const popup = document.createElement('div');
        popup.textContent = text;
        popup.classList.add('copy-popup');
        document.body.appendChild(popup);

        const rect = button.getBoundingClientRect();
        popup.style.top = `${rect.top + window.scrollY - 40}px`;
        popup.style.left = `${rect.left + rect.width / 2 - 40}px`;

        setTimeout(() => {
            popup.classList.add('fade-out');
            setTimeout(() => popup.remove(), 500);
        }, 1500);
    }
})();
